export default __webpack_public_path__ + "static/media/pattern-nosotros.51916518.svg";